import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import { showDateNoTime } from '@libs/NwMoment';

import { useUserPermission } from '@contexts/UserContext';

import { getCustomer } from '@hooks/API/Contact/UseContactsList';

import FlexContainer from '@components/Gui/FlexContainer';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDrawer from '@components/Gui/NwDrawer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import Visibilities from '@components/Gui/Visibilities';
import MediaDetailForm from '@components/MediaDrawer/MediaDetailForm';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const MediaDetailsCard = styled(NwCard)`
    margin-top: 16px !important;

    .ant-card-body {
        padding: 16px !important;
    }
`;

const DataFieldsTable = styled.table`
    list-style-type: none;
    padding-left: 0px;

    .title-cell {
        border-right: ${(props) => props.theme.DefaultBorder};
        padding-right: 40px;
        font-size: 0.8rem;
        text-transform: uppercase;
    }
    .content-cell {
        padding-left: 20px;
        font-size: 0.95rem;
    }
`;

const MediaDetails = ({ document, isEditDetail, contactID, viewOnly, onTouchForm, confirmDelete }) => {
    const [editing, setEditing] = useState(false);
    const userPermission = useUserPermission('DeleteMedia', [document.UserCreated]);

    useEffect(() => {
        if (isEditDetail) {
            setEditing(true);
        }
    }, [isEditDetail]);

    const getMediaItems = (item) => {
        let photographer = '';
        if (item.PhotographerID) {
            const customer = getCustomer(item.PhotographerID);
            if (customer) {
                photographer = customer.N;
            }
        }
        const legalItems = [];
        legalItems.push({
            label: 'Title',
            value: item.Title,
        });
        if (document.TypeName !== 'Document') {
            legalItems.push({
                label: 'Location',
                value: item.Location,
            });
            legalItems.push({
                label: 'Author',
                value: item.Author,
            });
            legalItems.push({
                label: 'Shooting Date',
                value: showDateNoTime(item.ShootingDate),
            });
        }
        legalItems.push({
            label: 'Notes',
            value: item.Notes,
        });
        if (document.TypeName !== 'Document') {
            legalItems.push({
                label: document.TypeName === 'Photo' ? 'Photographer' : 'Director',
                value: photographer,
            });
            legalItems.push({
                label: 'Public Description',
                value: item.PublicDescription ? item.PublicDescription : '',
            });
        }
        legalItems.push({
            label: 'Visibility',
            value: <Visibilities hideLabel visibilities={item.Visibility.Areas} />,
        });
        return legalItems;
    };

    const handleDelete = () => {
        if (!document.DocumentPlaylists.length) {
            confirmDelete();
        }
    };

    const renderContent = () => {
        const pictureItems = document && getMediaItems(document);
        return (
            <FlexContainer alignItems="flex-start" justifyContent="space-between" fullWidth>
                <DataFieldsTable>
                    <tbody>
                        {pictureItems.map((item, index) => (
                            <tr key={`picture-item-${index}`}>
                                <td className="title-cell">{item.label}</td>
                                <td className="content-cell">{item.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </DataFieldsTable>
                {/* <NwDescriptionList items={pictureItems} /> */}
                {!viewOnly && (
                    <NwDropDownMenu
                        actions={[
                            {
                                name: '',
                                key: 'edit',
                                pinned: true,
                                icon: byPrefixAndName.fasl['pen'],
                                action: () => handleEditMode(),
                            },
                            {
                                name: 'delete',
                                type: 'delete',
                                key: 'delete',
                                icon: byPrefixAndName.fasl['trash-alt'],
                                confirmationPlacement: 'left',
                                disabled: !userPermission || document.DocumentPlaylists.length > 0,
                                action: () => handleDelete(),
                                description:
                                    document.DocumentPlaylists.length > 0 &&
                                    'Please remove the picture from books before deleting it',
                            },
                        ]}
                    />
                )}
            </FlexContainer>
        );
    };

    const handleEditMode = () => {
        setEditing(true);
    };

    return (
        <MediaDetailsCard icon={byPrefixAndName.fasl['info-square']} title="Info">
            {renderContent()}
            {editing && (
                <NwDrawer title="Edit Detail" onClose={() => setEditing(false)}>
                    <MediaDetailForm
                        onTouchForm={onTouchForm}
                        onCancel={() => setEditing(false)}
                        document={document}
                        contactID={contactID}
                        isEditDetail={isEditDetail}
                    />
                </NwDrawer>
            )}
        </MediaDetailsCard>
    );
};

export default MediaDetails;
